"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccScrollSelectorStyle = (0, _react.useMemo)(function () {
    var ccScrollSelectorContainer = (0, _css.css)({
      fontFamily: fontFamily,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      direction: 'rtl',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      height: pxToRem(160),
      width: '100%',
      position: 'relative',
      fontSize: pxToRem(20)
    });
    var ccScrollSelector = (0, _css.css)({
      overflow: 'auto',
      scrollBehavior: 'smooth',
      flex: '1 1',
      '&::before': {
        content: '""',
        position: 'relative',
        display: 'block',
        height: pxToRem(64)
      },
      '&::after': {
        content: '""',
        position: 'relative',
        display: 'block',
        height: pxToRem(64)
      },
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    });
    var ccScrollSelectorItem = (0, _css.css)({
      textAlign: 'center',
      height: pxToRem(32),
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'space-evenly'
    });
    var ccScrollSelectorMask = (0, _css.css)({
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'linear-gradient(0deg,#fff,hsla(0,0%,100%,0) 30%,hsla(0,0%,100%,0) 70%,#fff)',
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        height: pxToRem(32),
        top: pxToRem(64),
        left: 0,
        right: 0,
        opacity: 0.2,
        background: '#000'
      }
    });
    return {
      ccScrollSelectorContainer: ccScrollSelectorContainer,
      ccScrollSelector: ccScrollSelector,
      ccScrollSelectorItem: ccScrollSelectorItem,
      ccScrollSelectorMask: ccScrollSelectorMask
    };
  }, [fontFamily, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text]);
  return {
    'cc-ScrollSelector': ccScrollSelectorStyle.ccScrollSelector,
    'cc-ScrollSelector-container': ccScrollSelectorStyle.ccScrollSelectorContainer,
    'cc-ScrollSelector__item': ccScrollSelectorStyle.ccScrollSelectorItem,
    'cc-ScrollSelector__mask': ccScrollSelectorStyle.ccScrollSelectorMask
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;